import React from "react";
import { Redirect } from "react-router-dom";
import { useJwt } from "react-jwt";

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");
  const { decodedToken } = useJwt(token);

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem("access_token");
    return <Redirect to="/login" />;
  }
  if (decodedToken === null) return null;
  if (decodedToken?.role !== "superAdmin") return <Redirect to="/" />;

  return children;
};

export default AdminRoute;
